import React from 'react';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import PropTypes from 'prop-types';

export default function NotificationListLink({
  disabled,
  href,
  link,
  children,
  modal,
  ...rest
}) {
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        <ListItem button {...rest}>
          {children}
        </ListItem>
      </a>
    );
  }
  if (modal) {
    return (
      <ListItem button {...rest}>
        {children}
      </ListItem>
    );
  }

  if (disabled) {
    return (
      <ListItem
        disabled
        {...rest}
      >
        {children}
      </ListItem>
    );
  }

  return (
    <Link to={link}>
      <ListItem button {...rest}>
        {children}
      </ListItem>
    </Link>
  );
}

NotificationListLink.propTypes = {
  disabled: PropTypes.bool,
  href: PropTypes.string,
  link: PropTypes.string,
  modal: PropTypes.object,
  children: PropTypes.any.isRequired,
};

NotificationListLink.defaultProps = {
  disabled: false,
  modal: undefined,
  href: undefined,
  link: '/',
};
